import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { useMutation } from '@/utils/api';

export interface CloudInitializeRequest {
  provider: string;
  org_account_id?: string;
  account_id?: string;
  tenant_id?: string;
  subscription_id?: string;
  org_id?: string;
  project_id?: string;
  deployment_type: string;
  call_as?: string;
  targets?: string;
  external_id?: string;
  workload_pool_id?: string;
  workload_provider_id?: string;
  service_account_id?: string;
  service_account_email?: string;
  image_scanning?: boolean;
}

export interface CloudInitializeResponse {
  username: string;
  password: string;
  template: string;
  quick_create_url?: string; // CloudFormation Quick Create deep link (only for cloudformation deployment_type)
}

export default function useInitialize() {
  const axios = useAxios();

  return useMutation<
    CloudInitializeResponse,
    Error,
    CloudInitializeRequest,
    unknown
  >({
    mutationFn: async (data: CloudInitializeRequest) => {
      const response = axios.post<CloudInitializeResponse>(
        '/cloud/initialize',
        data
      );

      toast.promise(response, {
        loading: 'Initializing cloud integration...',
        success: 'Cloud integration initialized successfully',
        error: 'Failed to initialize cloud integration',
      });

      return (await response).data;
    },

    defaultErrorMessage: 'Failed to initialize cloud integration',
  });
}
